export const IS_SSR = !((typeof window !== 'undefined' && window.document && window.document.createElement))